<template>
    <div>
        <b-tab :title="$tc('message.hospitalisations',1)" :active="pathHas($tc('message.hospitalisations',1))">

            <b-link class="ml-4" :to="{ name: 'add-hospitalisation' }" variant="primary" v-if="hasAdminRole  || hasPraticienRole || hasMedecinControleRole || hasAssistante">
                <i class="fas fa-plus-circle edit-icon"></i> {{ $tc('message.hospitalisations',2) }}
            </b-link>

            <b-card-body>
                <div v-if="!mobileView"> <!-- v-if="!mobileView" -->
                    <vue-good-table id="hospitalisation" v-if="notEmpty(hospitalisationsRows)" :columns="hospitalisationsColumns" :rows="hospitalisationsRows" :search-options="enabled" :pagination-options="paginationOptions" @on-row-click="onHospitalisationRowClick" />
                </div>
                <div id="table-demo" v-else> <!-- v-else -->
                    <div class="ltemp--content--box border border-1 px-2 px-md-4 py-2 my-2 mx-md-3 rounded bg-white" v-for="(row, x) in hospitalisationsRows" :key="x" @click="onHospitalisationRowClickMobile(row)"> <!-- @click="onHospitalisationRowClickMobile(row)" -->
                        <div class="trajet__info bg-white mt-2 px-2" > <!-- v-for="(item, index) in ligne_temps" :key="index" -->
                            <div class="trajet__info--text h-100 d-flex align-items-center justify-content-between fs-6">
                                <span class="d-flex align-items-center text-gray">
                                    <i class="fa fa-calendar" aria-hidden="true"></i>
                                    <span class="px-1">{{row.motifs}}</span>
                                </span>
                                <span class="d-none d-md-block"><i class="fa fa-minus" aria-hidden="true"></i></span>
                                <span class="text-default text-gray"> {{row.consultant}} </span>
                                <span class="d-none d-md-block"><i class="fa fa-minus" aria-hidden="true"></i></span>
                                <span class="text-default d-none d-md-block">{{row.date_entree}}</span>
                                <span class="d-none d-md-block"><i class="fa fa-minus" aria-hidden="true"></i></span>
                                <span class="text-default d-none d-md-block">{{row.date_sortie}}</span>
                                <span class="d-none d-md-block"><i class="fa fa-minus" aria-hidden="true"></i></span>
                                <span class="text-default d-none d-md-block" v-html="row.traitement"></span>
                                <span class="d-none d-md-block"><i class="fa fa-minus" aria-hidden="true"></i></span>
                                <span class="">
                                    <b-button class="border-0 p-0 d-flex align-items-center shadow-none bg-transparent text-primary" @click="onHospitalisationRowClickMobile(row) "><!-- :to="{ name: 'consultation-general' , params: { file: this.$route.params.file } }" -->
                                        <span class="d-none d-md-block">Voir</span>
                                        <i class="fa fa-eye" aria-hidden="true"></i>
                                    </b-button> 
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </b-card-body>
        </b-tab>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import $ from 'jquery';
import moment from "moment";
export default {
    name: "Hospitalisation",
    computed: {
         ...mapGetters(["file"]),

        mMedicalFile: function () {
            return _.isUndefined(this.file) ? [] : this.file;
        },
        mHospitalisations: function () {
            return (typeof this.mMedicalFile.hospitalisations == "object" ? this.mMedicalFile.hospitalisations : []);
        },
        hospitalisationsRows: function () {
            let hArray = [];
            let self = this;
            _.forEach(self.mHospitalisations, function (hospitalisation) {
                let motifs = "";
                _.forEach(hospitalisation.motifs, function (motif, key) {
                    motifs = motifs + (key != 0 ? " ," : "") + motif.description;
                })
                hArray.push({
                    date_entree: hospitalisation.date_entree,
                    date_sortie: hospitalisation.date_sortie,
                    traitement: hospitalisation.traitement_sortie,
                    motifs: motifs,
                    slug: hospitalisation.slug,
                    consultant: self.formatFullName(hospitalisation.author),
                    passedAt: hospitalisation.passed_at,
                    archievedAt: hospitalisation.archived_at
                })
            });
            let sArray = hArray;
            hArray = self.filterResult(sArray, hArray);
            return hArray;
        },
    },
    props: ['hasAdminRole', 'hasMedecinControleRole', 'hasAssistante', 'hasPraticienRole', 'file_id'],
    data() {
        return {
            mobileView: true,
            hospitalisationsColumns: [{
                    label: this.$i18n.tc('message.reasons', 1),
                    field: 'motifs',
                },
                {
                    label: this.$i18n.tc('message.practitioners', 1),
                    field: 'consultant',
                },
                {
                    label: this.$i18n.t('message.entryDate'),
                    field: 'date_entree',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'dd/MM/yyyy',
                },

                {
                    label: this.$i18n.t('message.exitDate'),
                    field: 'date_sortie',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'dd/MM/yyyy',
                },

                {
                    label: this.$i18n.t('message.exitTreatment'),
                    field: 'traitement',
                    html: true
                },
            ],
            paginationOptions: {
                enabled: true,
                mode: 'records',
                perPageDropdown: [3, 6, 10]
            },

            enabled: {
                enabled: true
            },

            sort: {
                enabled: true,
                initialSortBy: {
                    field: 'date',
                    type: 'desc'
                }
            },
            
        }
    },
    validations() {
        return {
            form: {
                responsable:{},
            }
        }
	},
    methods: {
        handleView() {
            this.mobileView = window.innerWidth <= 990;
        },
        formatFullName(author) {
            if (!_.isNull(author) && !_.isUndefined(author)) {
                if (author.hasOwnProperty('user')) {
                    let user = author.user
                    if (!_.isUndefined(user) && !_.isNull(user)) {
                        let prenom = (user.prenom == null) ? '' : user.prenom;
                        return (user.nom).toUpperCase() + " " + prenom.charAt(0).toUpperCase() + prenom.substring(1);
                    }
                } else {
                    if (!_.isUndefined(author) && !_.isNull(author)) {
                        let prenom = (author.prenom == null) ? '' : author.prenom;
                        return (author.nom).toUpperCase() + " " + prenom.charAt(0).toUpperCase() + prenom.substring(1);
                    }
                }
            }
            return "";
        },
        errorshasField(field) {
            return this.errors ? this.errors.hasOwnProperty(field) : false;
        },
        errorshasField(field) {
            return this.errors ? this.errors.hasOwnProperty(field) : false;
        },  
        filterResult(sArray, mArray) {
            if (this.filteredValue == 1) {
                mArray = sArray;
            } else if (this.filteredValue == 2) {
                //Non archivés
                mArray = _.filter(mArray, function (medecine) {
                    return _.isNull(medecine.archievedAt);
                })
            } else if (this.filteredValue == 3) {
                //Non transmis
                mArray = _.filter(mArray, function (medecine) {
                    return _.isNull(medecine.passedAt);
                })
            } else if (this.filteredValue == 4) {
                //Archivés
                mArray = _.filter(mArray, function (medecine) {
                    return !_.isNull(medecine.archievedAt);
                })
            } else if (this.filteredValue == 5) {
                //Transmis
                mArray = _.filter(mArray, function (medecine) {
                    return !_.isNull(medecine.passedAt);
                })
            }
            return mArray;
        },
        onHospitalisationRowClick(params) {
            this.$router.push({
                name: 'hospitalisation',
                params: {
                    hospitalisation: params.row.slug
                }
            });
        },
        onHospitalisationRowClickMobile(params) {
            this.$router.push({
                name: 'hospitalisation',
                params: {
                    hospitalisation: params.slug
                }
            });
        },
        pathHas(element) {
        let result = (this.$route.fullPath).includes(element);
            if (result) {
                if ($('#' + element).length) {
                    document.getElementById(element).scrollIntoView(top);
                }
            }

            return result;
        },
        notEmpty(item) {
            return item.length > 0;
        },
    },
    created() {
        this.handleView();
        window.addEventListener('resize', this.handleView);
    },
    mounted() {
        
    }
}
</script>
<style lang="">
    
</style>